export const colors = {
  primary: "#D03230",
};
